export const TIERS = [
  { max: 1, percent: 0 },
  { max: 6, percent: 0.25 },
  { max: 12, percent: 0.5 },
  { max: 18, percent: 0.75 },
  { max: Infinity, percent: 1 },
];
